<template>
  <footer class="footer">
    <div class="container">
      <div class="grid">
        <div class="grid_text f12">
          © {{ new Date().getFullYear() }}
          {{ localStorage.translations.pages.footer.text['vse-prava-zashchishcheny'] }}
        </div>
        <div class="buttons">
          <a
            class="link"
            href="https://apps.apple.com/fi/app/proapp-2-0/id1667509098"
            target="_blank"
            rel="nofollow noopener"
          >
            <img src="~/assets/img/apple_store.svg" alt="apple-store" />
          </a>
          <a
            class="link"
            href="https://play.google.com/store/apps/details?id=com.siacom.proapp"
            target="_blank"
            rel="nofollow noopener"
          >
            <img src="~/assets/img/google_play.svg" alt="google-play" />
          </a>
        </div>
        <div class="grid_logo">
          <img src="~/assets/img/logo_footer.svg" alt="ProApp" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      pageName: 'footer',
    }
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: var(--v-secondary-lighten5);
}
.grid {
  display: grid;
  grid-template-columns: max-content max-content;
  justify-items: center;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px;
  column-gap: 286px;
  position: relative;
  &_logo {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    img,
    svg {
      height: 54px;
      cursor: auto;
    }
  }
  .buttons {
    justify-self: center;
    display: grid;
    grid-template-columns: max-content max-content;
    gap: 20px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    .link {
      line-height: 0;
      position: relative;
      overflow: hidden;
      img {
        // max-width: 144px;
        width: 100%;
        height: auto;
        max-height: 37px;
      }
      &:after {
        background: #fff;
        content: '';
        height: 155px;
        left: -75px;
        opacity: 0.2;
        position: absolute;
        top: -50px;
        transform: rotate(35deg);
        transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
        width: 50px;
        z-index: 10;
      }
      &:hover {
        &:after {
          left: 120%;
          transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
        }
      }
    }
  }
  @media screen and (max-width: 1100px) {
    grid-template-columns: max-content max-content max-content;
    column-gap: 10px;
    .buttons {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
    justify-content: center;
    justify-items: center;
    padding: 20px 12px;
    .buttons {
      position: static;
      transform: none;
    }
  }
}
</style>
